export default __webpack_public_path__ + "static/by-52fca29ff37324fceb6c9fde9f31c044.svg";